import { IconButton, makeStyles, Step, StepConnector, StepLabel, Stepper, withStyles } from "@material-ui/core";
import { TextBox } from "devextreme-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { associateContract, getContract, getContractSimple } from "../../redux/contract/thunks";
import { markCaseWithoutPlate } from "../../redux/cases/thunks";
import { selectContract } from "../../redux/contract/selectors";
import { selectCurrentCase } from "../../redux/currentCase/selectors";
import {Button as TextBoxButton } from 'devextreme-react/text-box';
import searchIcon from "../../images/ui-ic-search.svg"
import saveIcon from "../../images/save.svg"
import { openModal } from "../../redux/modal/modalSlice";
import { faVuejs } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";


function customStepIcon(stepValue, npsValue){
  let color = "#EFF1F2";

  if(npsValue){

    if(stepValue < 0){
        color = stepValue < npsValue ? "#EFF1F2" : "#D50005"
    }
    
    if(stepValue > 0 ){
        color = stepValue > npsValue ? "#EFF1F2" : npsValue <=50 ? "#D50005" : "#007BC0"
    }

    if(stepValue == 0){
       color = npsValue <= 50 ? "#D50005" : "#007BC0"
    }

  }

  return <div style={{width: "1rem", height: "1rem", borderRadius: "0.5rem", backgroundColor: color  }}></div>

}

const CustomConnector = withStyles({
  alternativeLabel: {
    top: "0.5rem",
    left: "calc(-50% + 0.50rem)",
    right: "calc(50% + 0.50rem)",
  },
  line: {
    height: "0.15rem",
    border: 0,
    blockSize: "border-box",
    backgroundColor: "#71767C"
  },
})(StepConnector);


const useStyles = makeStyles({
  stepper:{
    padding: "1rem 0"
  },
  step:{
    padding: 0
  },
  alternativeLabel:{
    marginTop: "0.25rem !important"
  }
})


function ContractSearch(props){
  const { t } = useTranslation();
    const classes = useStyles();
    const contract = useSelector(selectContract)
    const [searchField, setSearchField] = useState("");
    const currentCase = useSelector(selectCurrentCase);
    const initialSearch = useRef(true);
    const dispatch = useDispatch();
    const location = useLocation();

async function handleSearch(e){
  if(searchField === ""){ 
    dispatch(openModal({type: "info", message: "Introduzca una matrícula válida"}));
    return
  }
  const searchParams= {query: "?plate="+searchField};
  if((!contract.plate || contract.unassigned) && (contract.case?.closeDate === null && !contract.case?.state.toLowerCase().includes("gestionado")))
    {
      dispatch(getContractSimple(searchParams))
    }
  else { 
    dispatch(getContract(searchParams));
  }

}

useEffect(() => {
  if(location?.state?.plate) {
    setSearchField(location.state.plate);
  }
}, []);

useEffect(() => {
  if(location?.state?.plate && initialSearch.current && searchField == location.state.plate) {
    initialSearch.current = false;
    delete location.state.plate;
    handleSearch();
  }
}, [searchField]);

async function handleAssign(){
dispatch(associateContract({body:{plate: contract.plate, caseId: contract.case.caseId}}))
}

async function handleNoPlate(){
  dispatch(markCaseWithoutPlate({query:`?caseId=${contract.case?.caseId}`}))
}

const steps =[-100, -75, -50, -25, "0", 25, 50, 75, 100];

function hasExpired(){
const now = dayjs();
const contractEndDate = dayjs(contract.contractEndDate, "DD/MM/YYYY")
const difference1 = now.diff(contractEndDate);
if(difference1 > 0){return true}
else return false
}

    return(
                <div className="panel-plate-search-cell">
                  <div className="panel-plate-info">
                      <div style={{display: "grid", alignItems: "center", columnGap: "0.25rem", gridTemplateColumns: "max-content min-content min-content"}}>
                            <div style={{display: 'flex', gap: '.5rem', fontSize: "1rem"}}>
                                <span style={{fontSize: "1rem", fontWeight: 700}}>{t("Customer")}: </span>
                                {/* {contract?.plate && <span style={{color: hasExpired()? "#E20015" : "#000" }}>{contract?.plate}</span>} */}
                                {/* {contract?.plate && <span style={{color: "#000"}}>{contract?.plate}</span>} */}

                                {contract?.customerName && <span style={{color: "#000"}}>{contract?.customerName}</span>}

                                {contract?.case?.mspPlate && <span style={{color: "#000"}}> | </span>}
                                {contract?.case?.mspPlate && <span style={{color: "#000"}}>{contract?.case?.mspPlate}</span>}
                                
                            </div>
                            
                            <div style={{display: "flex", alignItems: "center", columnGap: "0.25rem"}}>
                                {contract?.unassigned && contract.case.closeDate === null && 
                                    <span>
                                        <IconButton onClick={handleAssign}><img src={saveIcon} alt="salvar" title={"Asignar matrícula"} width={20}/></IconButton>
                                    </span>}
                                {(contract.plate == null || contract?.unassigned )&& contract?.case && !contract.case.withoutPlate && (contract?.case.state !=="Cerrado" && !contract?.case.state.toLowerCase().includes("gestionado")) && !currentCase.withoutPlate && <span>
                                  <IconButton onClick={handleNoPlate}>
                                      <i className="icon icon-alert-success" alt={"Sem cliente"} title="Marcar caso como sem cliente"></i>
                                  </IconButton></span>} 
                            </div>           
                              {(contract.plate == null || contract?.unassigned )&& contract?.case && contract.case.withoutPlate && (contract?.case.state !=="Cerrado" || !contract?.case.state.toLowerCase().includes("gestionado")) && currentCase.withoutPlate && 
                                <span>
                                    <i style={{fontSize: "1.5rem", color:"#78BE20"}} className="icon icon-alert-success" alt={"Sem cliente"} title="Marcado como sem cliente"></i>
                                </span>}
                                {/* <div style={{display: "flex", alignItems: "center", columnGap: "0.25rem"}}>
                                                  {contract && contract.exceptions && contract.exceptions.length > 0 && <div style={{color: "#ffcf00", fontSize: "1.5rem"}}> <i className="icon icon-alert-warning" title="El cliente tiene Exceções" /></div>}
                                                  {contract && contract.vip && <div> <FontAwesomeIcon icon={faVuejs} color="#B9C40E" transform={{ size: 30 }} title="VIP"  /></div>}
                                                  {contract && contract.highLevel && <div style={{color:"#78BE20", fontSize: "1.5rem"}}> <i className="icon icon-dollar" title="High Level"  /></div>}
                                                  {contract && contract.alphacity && <div> <i style={{color:"#E20015", fontSize: "1.75rem"}} className="icon icon-alphacity"  title="Alphacity" /></div>}  
                                                  {contract && contract.vipVehicle && <div style={{color: "#ffcf00", fontSize: "1.5rem"}}> <i className="icon icon-car" title="Premium" /></div>}   
                                </div> */}
                      </div>
                          <TextBox
                            label={t("Search")}
                            labelMode="floating"
                            value={searchField}
                            mode="text"
                            onValueChange={(value)=>setSearchField(value)}
                            onEnterKey={()=>handleSearch()}
                            valueChangeEvent="keyup"
                            >     
                              <TextBoxButton
                                  name="search"
                                  location="after"
                                  options={{
                                      icon: searchIcon,
                                      stylingMode: 'text',
                                      onClick: ()=>handleSearch(),
                                  }}
                              />
                          </TextBox>
                  </div>
                  {/* <div className="panel-nps-info">
                      <span style={{fontSize: "1rem", fontWeight: 700}}>QMAI Score:</span>                 
                      <span>  
                          <Stepper classes={{root: classes.stepper}} connector={<CustomConnector backgroundColor={"backgroundColor"}/>} alternativeLabel activeStep={null}>
                            {steps.map(step=>
                              <Step classes={{horizontal: classes.step}}>
                                <StepLabel classes={{label: classes.alternativeLabel}} StepIconComponent={()=>customStepIcon(step, contract.nps)}>{step}</StepLabel>
                              </Step>
                            )}
                          </Stepper>
                      </span>
                  </div> */}
              </div>
    )
}

export {ContractSearch}